/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface GetAccountName$Request {
    requestBody: Array<number>;
}

export interface GetAccountName$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountNameRequest = createAction<PayloadData<void, GetAccountName$Request>>('GET_ACCOUNT_NAME__GET_ACCOUNT_NAME__REQUEST');
export const getAccountNameSuccess = createAction<PayloadData<{ [key: string]: string; }, GetAccountName$Request>>('GET_ACCOUNT_NAME__GET_ACCOUNT_NAME__SUCCESS');
export const getAccountNameFailure = createAction<PayloadData<Error, GetAccountName$Request, true>>('GET_ACCOUNT_NAME__GET_ACCOUNT_NAME__FAILURE');

export const getAccountNameActions = [
    getAccountNameRequest,
    getAccountNameSuccess,
    getAccountNameFailure
] as const;

/**
 * @param {Array<number>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountName = (meta: GetAccountName$Request, config?: GetAccountName$Config) => {
    return {
        CALL_API: {
            types: getAccountNameActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/accounts/names`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

